import MenuState from './MenuState';
export const states = {
  MenuState: MenuState
};
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/states', null);